import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import DocumentTitle from 'react-document-title'
import { config } from 'config'

export default class Index extends React.Component {
  render () {
    let logo = "/images/logo.svg",
        landingImage = "/images/landing-img.svg",
        snoozeIcon = "/images/snz-icon.svg",
        bucketIcon = "/images/bck-icon.svg",
        emailIcon = "/images/eml-icon.svg",
        chromeIcon = "/images/crm-icon.svg",
        cogIcon = "/images/cog-icon.svg",
        phoneIcon = "/images/phn-icon.svg",
        individualIcon = "/images/individual-icon.svg",
        teamIcon = "/images/team-icon.svg",
        enterpriseIcon = "/images/enterprise-icon.svg",
        profilePicture = "/images/prof-pic.png";

    return (
      <DocumentTitle title={config.siteTitle}>
        <div>
          <header>
            <div className="container">
              <div className="row">
                <div className="col-sm-6 logo-cage">
                  <a className="logo" href="index.html">
                    <img src='/images/logo.svg'/>
                  </a>
                </div>
                <div className="spacer short visible-xs visible-sm"></div>
                <div className="col-sm-6 nav-cage">
                  <ul className="nav inline-list">
                    <li><a className="feature-btn" href="#">FEATURES</a></li>
                    <li><a href="#">ABOUT</a></li>
                    <li><a href="http://app.setterapp.com/login">LOGIN</a></li>
                    <li><a className="signup-btn setter-btn" href="#">SIGN UP</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </header>

          <div className="hero">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 text-center">
                  <h1 className="title">Manage your candidate prospecting and sourcing with ease.</h1>
                  <div className="spacer"></div>
                  <p className="text-center sub-title">Setter is for managing your relationships with people who could be a great fit for your company. Never let a great person fall through the cracks or be forgotten again!</p>
                  <div className="spacer tall"></div>
                  <a className="tryout-btn setter-btn" href="#">REQUEST A DEMO</a>
                </div>
              </div>

              <div className="spacer giant"></div>

              <div className="img-box text-center">
                <img src="images/landing-img.svg"/>
              </div>
            </div>
          </div>

          <div className="curva"></div>

          <div className="feature-box">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <h2 className="title text-center">FEATURES</h2>
                </div>
              </div>

              <div className="spacer giant hidden-xs hidden-sm"></div>
              <div className="spacer tall"></div>

              <div className="row">
                <div className="col-sm-4 feature-cage">
                  <svg width="50px" height="41px" viewBox="0 0 50 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="mockup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="Wireframe-Copy-5" transform="translate(-370.000000, -1293.000000)" fill="#27CA92">
                              <path d="M374.933,1323.8922 L398.558,1323.8922 C396.442,1322.6482 395.476,1320.6202 394.469,1318.5022 L394.027,1317.5782 L394.027,1311.0682 C394.027,1307.0532 390.76,1303.7882 386.746,1303.7882 C382.731,1303.7882 379.465,1307.0532 379.465,1311.0682 L379.465,1317.5782 L379.021,1318.5072 C378.014,1320.6222 377.048,1322.6492 374.933,1323.8922 L374.933,1323.8922 Z M403.492,1327.8922 L370,1327.8922 L370,1321.2732 L371.577,1320.9312 C373.571,1320.4992 374.158,1319.4152 375.409,1316.7882 L375.465,1316.6692 L375.465,1311.0682 C375.465,1304.8482 380.526,1299.7882 386.746,1299.7882 C392.966,1299.7882 398.027,1304.8482 398.027,1311.0682 L398.027,1316.6692 L398.081,1316.7852 C399.332,1319.4142 399.92,1320.4992 401.915,1320.9312 L403.492,1321.2732 L403.492,1327.8922 Z M380.5176,1329.6822 C381.6576,1331.9712 384.0146,1333.5482 386.7456,1333.5482 C389.4776,1333.5482 391.8336,1331.9712 392.9736,1329.6822 L380.5176,1329.6822 Z M400.3297,1308.4709 L406.2667,1299.9259 L406.2667,1299.8519 L400.8857,1299.8519 L400.8857,1297.5219 L409.9287,1297.5219 L409.9287,1299.1499 L404.1217,1307.5829 L404.1217,1307.6569 L410.0207,1307.6569 L410.0207,1309.9869 L400.3297,1309.9869 L400.3297,1308.4709 Z M411.7054,1300.435 L414.5544,1296.865 C415.0714,1296.255 415.4784,1295.811 415.9964,1295.256 L415.9964,1295.219 L412.0194,1295.219 L412.0194,1293 L419.4174,1293 L419.4174,1294.683 L416.6994,1298.104 C416.1994,1298.696 415.7374,1299.269 415.2194,1299.769 L415.2194,1299.806 L419.5664,1299.806 L419.5664,1302.044 L411.7054,1302.044 L411.7054,1300.435 Z" id="Combined-Shape"></path>
                          </g>
                      </g>
                  </svg>
                  <h3 className="name">Snooze</h3>
                  <hr className="separator"/>
                  <p className="content">
                    Want to be reminded to reach out to someone in a few weeks? Snooze them. Found someone great who wants to reconnect in 6 months? You guessed it! This is one of our most loved features.
                  </p>
                  <div className="spacer tall visible-xs visible-sm"></div>
                </div>
                <div className="col-sm-4 feature-cage">
                  <svg width="40px" height="38px" viewBox="0 0 40 38" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="mockup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="Wireframe-Copy-5" transform="translate(-770.000000, -1296.000000)" fill="#27CA92">
                              <path d="M778.460873,1324.2591 L779.199807,1329.43946 C779.456949,1333.66858 789.260759,1334.00055 792.29314,1334.00055 C795.326473,1334.00055 805.130283,1333.66858 805.387426,1329.43946 L809.417812,1301.18411 C809.418968,1301.17845 809.420101,1301.1728 809.42121,1301.16715 C809.450335,1301.02053 809.463616,1300.87568 809.463616,1300.7326 C809.463616,1300.69507 809.462524,1300.65777 809.460368,1300.62074 C809.35744,1298.48545 806.24035,1296 792.293521,1296 C778.301131,1296 775.209351,1298.50172 775.125761,1300.64166 C775.124336,1300.6718 775.123616,1300.70212 775.123616,1300.7326 C775.123616,1300.84835 775.132308,1300.96525 775.151048,1301.08332 C775.156458,1301.11787 775.162716,1301.15249 775.169854,1301.18715 L776.116658,1307.8248 C771.724049,1313.06607 767.899482,1320.26641 771.313711,1323.67554 C772.014664,1324.37564 773.117521,1324.99774 774.826092,1324.99774 C775.819555,1324.99774 777.018224,1324.78749 778.460873,1324.2591 Z M777.907995,1320.38311 L776.870482,1313.10954 C773.996833,1317.30849 773.379941,1320.35898 774.007997,1320.98549 C774.310643,1321.28777 775.624121,1321.3632 777.907995,1320.38311 Z M781.474508,1318.41373 L779.454092,1304.24736 C782.060759,1304.97694 786.114092,1305.46397 792.29314,1305.46397 C798.47314,1305.46397 802.526473,1304.97694 805.13314,1304.24736 L801.638854,1328.74221 C800.748378,1329.30914 797.472188,1330.19568 792.29314,1330.19568 C787.114092,1330.19568 783.837902,1329.30819 782.947426,1328.74126 L782.061261,1322.52781 C784.759778,1320.95192 787.607681,1318.71069 790.267997,1316.05437 C791.997521,1314.32696 793.547045,1312.52725 794.875616,1310.70566 C795.493711,1309.85622 795.307045,1308.66625 794.455616,1308.04796 C793.60514,1307.42776 792.414664,1307.61705 791.794664,1308.46649 C790.584188,1310.12827 789.164188,1311.77674 787.574664,1313.36432 C785.579012,1315.35692 783.488904,1317.08207 781.474508,1318.41373 Z M803.401229,1300.73214 C801.093536,1300.24804 797.336701,1299.80488 792.293521,1299.80488 C787.250316,1299.80488 783.493469,1300.24804 781.185779,1300.73214 C783.493086,1301.21596 787.2495,1301.65909 792.29314,1301.65909 C797.336804,1301.65909 801.093643,1301.21596 803.401229,1300.73214 Z" id="Combined-Shape"></path>
                          </g>
                      </g>
                  </svg>
                  <h3 className="name">Buckets</h3>
                  <hr className="separator"/>
                  <p className="content">
                    Buckets help you keep everyone organized. Buckets can be used to group people for a position or by a skillset. They are the power filter. Put people in as many buckets as you need. We have plenty.
                  </p>
                  <div className="spacer tall visible-xs visible-sm"></div>
                </div>
                <div className="col-sm-4 feature-cage">
                  <svg width="40px" height="41px" viewBox="0 0 40 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="mockup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="Wireframe-Copy-5" transform="translate(-1170.000000, -1293.000000)" fill="#27CA92">
                              <path d="M1174,1329.2813 L1206,1329.2813 L1206,1314.6803 L1190.972,1323.0303 C1190.366,1323.3643 1189.634,1323.3643 1189.028,1323.0303 L1174,1314.6803 L1174,1329.2813 L1174,1329.2813 Z M1208,1333.2813 L1172,1333.2813 C1170.895,1333.2813 1170,1332.3853 1170,1331.2813 L1170,1311.2813 C1170,1310.5733 1170.374,1309.9173 1170.985,1309.5573 C1171.598,1309.1983 1172.351,1309.1893 1172.972,1309.5323 L1190,1318.9933 L1207.028,1309.5323 C1207.648,1309.1893 1208.401,1309.1973 1209.015,1309.5573 C1209.625,1309.9173 1210,1310.5733 1210,1311.2813 L1210,1331.2813 C1210,1332.3853 1209.105,1333.2813 1208,1333.2813 Z M1181.875,1305.1873 L1197.564,1305.1873 L1197.564,1301.1873 L1181.875,1301.1873 L1181.875,1305.1873 Z M1181.874,1311.3123 L1193.749,1311.3123 L1193.749,1307.3123 L1181.874,1307.3123 L1181.874,1311.3123 Z M1205.625,1307.25 L1201.625,1307.25 L1201.625,1297 L1177.625,1297 L1177.625,1307.25 L1173.625,1307.25 L1173.625,1295 C1173.625,1293.896 1174.521,1293 1175.625,1293 L1203.625,1293 C1204.73,1293 1205.625,1293.896 1205.625,1295 L1205.625,1307.25 Z" id="Combined-Shape"></path>
                          </g>
                      </g>
                  </svg>
                  <h3 className="name">Email</h3>
                  <hr className="separator"/>
                  <p className="content">
                    We play nicely with email. Setter integrates with your email and can automatically pull in all emails you exchange with a prospect. You can even send email from Setter and send bulk email using templates.
                  </p>
                  <div className="spacer tall visible-xs visible-sm"></div>
                </div>
              </div>

              <div className="spacer giant hidden-xs hidden-sm"></div>

              <div className="row">
                <div className="col-sm-4 feature-cage">
                  <svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="mockup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="Wireframe-Copy-5" transform="translate(-370.000000, -1605.000000)" fill="#27CA92">
                              <path d="M406.491769,1617.00367 C405.054636,1614.91847 403.142794,1613.11212 400.803673,1611.76163 C393.293975,1607.4259 383.917176,1609.2535 378.530589,1615.67495 L382.805096,1623.07862 C382.961075,1622.71434 383.140349,1622.3554 383.343419,1622.00367 C385.22823,1618.73909 388.675808,1616.93929 392.195622,1617.00367 L406.491769,1617.00367 Z M408.548459,1621 C410.256322,1625.714 409.948855,1631.12171 407.245721,1635.80367 C404.242824,1641.00484 398.986065,1644.09345 393.421406,1644.54809 L400.663927,1632.00367 C402.728389,1628.42792 402.333517,1624.10714 400.00413,1621 L408.548459,1621 Z M376.101314,1619.45998 C372.198176,1627.6647 375.199159,1637.62431 383.203673,1642.24572 C385.029563,1643.2999 386.965827,1643.98973 388.928278,1644.33776 L393.204021,1636.93196 C391.127546,1637.18462 388.954709,1636.79036 387.003673,1635.66393 C385.372306,1634.72206 384.106722,1633.38994 383.256758,1631.85357 L376.101314,1619.45998 Z M372.951115,1616.00367 C366.875982,1626.52611 370.481236,1639.9811 381.003673,1646.05623 C391.526111,1652.13136 404.9811,1648.52611 411.056232,1638.00367 C417.131365,1627.48124 413.526111,1614.02625 403.003673,1607.95111 C392.481236,1601.87598 379.026247,1605.48124 372.951115,1616.00367 Z M386.826621,1624.0147 C385.175857,1626.87391 386.155494,1630.52996 389.014701,1632.18073 C391.873908,1633.83149 395.529962,1632.85185 397.180726,1629.99265 C398.83149,1627.13344 397.851853,1623.47738 394.992646,1621.82662 C392.133439,1620.17586 388.477385,1621.15549 386.826621,1624.0147 Z" id="Combined-Shape"></path>
                          </g>
                      </g>
                  </svg>
                  <h3 className="name">Chrome Extension</h3>
                  <hr className="separator"/>
                  <p className="content">
                    You spend a lot of time online searching and researching prospective candidates. Don't interrupt your workflow by switching tabs and copy-pasting. We do our best to automatically collect the information you need on someone and make it simple to add them to Setter.
                  </p>
                  <div className="spacer tall visible-xs visible-sm"></div>
                </div>
                <div className="col-sm-4 feature-cage">
                  <svg width="41px" height="41px" viewBox="0 0 41 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="mockup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="Wireframe-Copy-5" transform="translate(-770.000000, -1609.000000)" fill="#27CA92">
                              <path d="M800.0703,1615.0007 C797.8643,1615.0007 796.0703,1616.7947 796.0703,1619.0007 C796.0703,1621.2067 797.8643,1623.0007 800.0703,1623.0007 C802.2763,1623.0007 804.0703,1621.2067 804.0703,1619.0007 C804.0703,1616.7947 802.2763,1615.0007 800.0703,1615.0007 L800.0703,1615.0007 Z M774.538591,1625.036 C774.914496,1623.57152 775.49284,1622.18218 776.246187,1620.90319 L773.0404,1617.6974 L778.6964,1612.0404 L781.902122,1615.24669 C783.20052,1614.4826 784.624378,1613.89288 786.1462,1613.5128 L787.1152,1617.3928 C785.205938,1617.86994 783.502283,1618.78724 782.100897,1620.0209 L781.025631,1621.09617 C779.14692,1623.23011 778.0352,1626.02384 778.0352,1629.0358 C778.0352,1635.6528 783.4182,1641.0358 790.0352,1641.0358 C795.3222,1641.0358 799.9282,1637.6478 801.4962,1632.6048 L805.3162,1633.7928 C804.942724,1634.99321 804.440234,1636.12334 803.826588,1637.17002 L807.031,1640.375 L801.373,1646.031 L798.175036,1642.83247 C796.894095,1643.58601 795.502448,1644.16265 794.035,1644.53666 L794.035,1649.071 L786.035,1649.071 L786.035,1644.52952 C784.569053,1644.15077 783.183885,1643.5689 781.911442,1642.81586 L778.6963,1646.031 L773.0403,1640.375 L776.255365,1637.15994 C775.502212,1635.88739 774.920263,1634.50209 774.541476,1633.036 L770,1633.036 L770,1625.036 L774.538591,1625.036 Z M792.323335,1617.001 C792.512773,1616.26763 792.803881,1615.57468 793.180661,1614.93816 L791.5858,1613.3433 L794.4138,1610.5153 L796.008892,1612.11039 C796.644926,1611.73404 797.337282,1611.44322 798.07,1611.25389 L798.07,1609 L802.07,1609 L802.07,1611.25373 C802.803182,1611.44312 803.495956,1611.73413 804.132336,1612.11076 L805.7278,1610.5153 L808.5558,1613.3433 L806.96031,1614.93879 C807.33691,1615.57514 807.62789,1616.26787 807.817265,1617.001 L810.07,1617.001 L810.07,1621.001 L807.81711,1621.001 C807.627775,1621.73374 807.336942,1622.42612 806.960571,1623.06217 L808.5555,1624.6571 L805.7275,1627.4851 L804.132776,1625.89038 C803.496275,1626.26714 802.803351,1626.55823 802.07,1626.74767 L802.07,1629.001 L798.07,1629.001 L798.07,1626.74751 C797.337113,1626.55814 796.644607,1626.26723 796.008452,1625.89075 L794.4141,1627.4851 L791.5861,1624.6571 L793.180401,1623.0628 C792.80385,1622.42658 792.512888,1621.73398 792.32349,1621.001 L790.07,1621.001 L790.07,1617.001 L792.323335,1617.001 Z" id="Combined-Shape"></path>
                          </g>
                      </g>
                  </svg>
                  <h3 className="name">Integrations</h3>
                  <hr className="separator"/>
                  <p className="content">
                    We work with you not against you. Easy to set up and use integrations with your favorite Applicant Tracking Systems like Greenhouse and Jazz, and of course your chat application like Slack and HipChat.
                  </p>
                  <div className="spacer tall visible-xs visible-sm"></div>
                </div>
                <div className="col-sm-4 feature-cage">
                  <svg width="24px" height="40px" viewBox="0 0 24 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="mockup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="Wireframe-Copy-5" transform="translate(-1170.000000, -1609.000000)" fill="#27CA92">
                              <g id="Group" transform="translate(1170.000000, 1609.000000)">
                                  <path d="M4,36 L20,36 L20,4 L4,4 L4,36 Z M22,40 L2,40 C0.895,40 0,39.105 0,38 L0,2 C0,0.895 0.895,0 2,0 L22,0 C23.105,0 24,0.895 24,2 L24,38 C24,39.105 23.105,40 22,40 L22,40 Z" id="Fill-1"></path>
                                  <path d="M4,8 L20,8 L20,4 L4,4 L4,8 Z M22,12 L2,12 C0.895,12 0,11.104 0,10 L0,2 C0,0.895 0.895,0 2,0 L22,0 C23.105,0 24,0.895 24,2 L24,10 C24,11.104 23.105,12 22,12 L22,12 Z" id="Fill-3"></path>
                                  <path d="M4,36 L20,36 L20,32 L4,32 L4,36 Z M22,40 L2,40 C0.895,40 0,39.105 0,38 L0,30 C0,28.895 0.895,28 2,28 L22,28 C23.105,28 24,28.895 24,30 L24,38 C24,39.105 23.105,40 22,40 L22,40 Z" id="Fill-4"></path>
                              </g>
                          </g>
                      </g>
                  </svg>
                  <h3 className="name">Mobile</h3>
                  <hr className="separator"/>
                  <p className="content">
                    We have an iOS app in the works. Being able to add and search for prospects while you are out and about is invaluable. Let us know if you are interested in this.
                  </p>
                  <div className="spacer tall visible-xs visible-sm"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="spacer giant"></div>
          <div className="spacer giant"></div>


          <div className="client-box">
            <div className="spacer giant"></div>
            <div className="container">
              <div className="row">
                <div className="col-xs-12 text-center">
                  <h2 className="title text-center">WHAT OUR CUSTOMERS SAY</h2>
                  <div className="spacer"></div>
                  <div className="spacer giant"></div>
                  <div className="content-box">
                    <div className="text-box">
                      <p>"Setter has changed my entire workflow. The ability to keep conversations and notes on prospects in one place is huge."</p>
                    </div>

                    <div className="separator-ver"></div>

                    <div className="spacer tall visible-xs visible-sm"></div>

                    <div className="user-box">
                      <div className="img-box">
                        <img src="images/prof-pic.png"/>
                      </div>

                      <div className="spacer short visible-xs visible-sm"></div>

                      <div className="id-box">
                        <h6 className="name">Brad Pitt</h6>
                        <h6 className="title">CPO, Movies</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="spacer giant"></div>
            <div className="spacer tall"></div>
          </div>


          <div id="pricing" className="pricing-cage">
            <h2 className="title text-center">PRICING</h2>

            <div className="spacer-tall"></div>
            <div className="spacer-tall"></div>

            <div className="SetterBase-row">
              <div className="SetterBase-medium-center-col SetterBase-large-c-10 SetterBase-col">
                <div className="row">
                  <div className="SetterBase-medium-c-4 SetterBase-col">
                    <div className="price-card text-center">
                      <h4 className="title">INDIVIDUAL</h4>
                      <div className="icon-box"><img src={individualIcon}/></div>
                      <div className="price-box">
                        <h3 className="price">$99</h3>
                        <h5 className="per-month"><span className="green-col">/</span> Month</h5>
                      </div>
                      <div className="divider"></div>
                      <ul>
                        <li>For solo recruiters</li>
                        <li>1 Account</li>
                        <li>Email Support</li>
                        <li>2 month FREE trial</li>
                      </ul>
                      <div className="btn-box">
                        <Link
                          to='/register?beta_token=EARLYBIRD&plan_id=individual'
                          className="btn btn-trial">
                            Start your Free trial
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="SetterBase-medium-c-4 SetterBase-col">
                    <div className="price-card text-center">
                      <h4 className="title">TEAM</h4>
                      <div className="icon-box"><img src={teamIcon}/></div>
                      <div className="price-box">
                        <h3 className="price">$299</h3>
                        <h5 className="per-month"><span className="green-col">/</span> Month</h5>
                      </div>
                      <div className="divider"></div>
                      <ul>
                        <li>For a team of recruiters</li>
                        <li>25 team members</li>
                        <li>Email Support</li>
                        <li>2 month FREE trial</li>
                      </ul>
                      <div className="btn-box">
                        <Link
                          to='/register?beta_token=EARLYBIRD&plan_id=team'
                          className="btn btn-trial">
                            Start your Free trial
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="SetterBase-medium-c-4 SetterBase-col">
                    <div className="price-card enterprise-card text-center">
                      <h4 className="title">ENTERPRISE</h4>
                      <div className="icon-box"><img src={enterpriseIcon}/></div>
                      <div className="divider"></div>
                      <ul>
                        <li>Unlimited team members</li>
                        <li>Phone support</li>
                        <li>Multiple teams</li>
                        <li>2 month FREE trial</li>
                      </ul>
                      <div className="btn-box">
                        <button className="btn btn-trial" onClick={this._openRequestDemoModal}>CONTACT US</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>


          <footer>
            <div className="container">
              <div className="row">
                <div className="col-sm-6 copy-cage">
                  <h4 className="copy">© 2016 SiftedWheat LLC</h4>
                </div>
                <div className="col-sm-6 nav-btm-cage">
                  <ul className="nav-btm nav inline-list">
                    <li><a href="#">FEATURES</a></li>
                    <li><a href="#">ABOUT</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </footer>
          {/*<!-- jQuery (necessary for Bootstrap's JavaScript plugins) -->*/}
          <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script>
          {/*<!-- Include all compiled plugins (below), or include individual files as needed -->*/}
          {/*<script src="js/bootstrap.min.js"></script>*/}
          {/*<script src="js/script.js"></script>*/}
        </div>
      </DocumentTitle>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./OLD_index.js
 **/